// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as ReactRouterDom$BenfaerberBlog from "../wrappers/ReactRouterDom.bs.js";

function s(prim) {
  return prim;
}

function SmallProjectItem(props) {
  var project = props.project;
  var slug = project.slug;
  var title = project.title;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(ReactRouterDom$BenfaerberBlog.Link.make, {
                    children: [
                      JsxRuntime.jsx("h3", {
                            children: title,
                            className: "black-link"
                          }),
                      JsxRuntime.jsx("img", {
                            alt: title,
                            src: "/projects/images/thumbnails/" + slug + ".webp"
                          })
                    ],
                    href: "/projects/" + slug
                  }, slug),
              className: "column is-one-quarter-desktop is-half-mobile about-me-project"
            }, slug);
}

var make = SmallProjectItem;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
